import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 50px 80px;
  color: #333;

  iframe {
    margin: 30px 0;
    width: 100%;
    height: 40vh;
    border-radius: 5px;
  }

  @media (max-width: 900px) {
    padding: 50px;
  }

  @media (max-width: 280px) {
    padding: 30px;
  }
`;

export const Title = styled.p`
  color: #0000ff;
  font-size: 1.75rem;
  font-weight: 600;
  text-align: left;
  width: 100%;
`;

export const Emphasis = styled.span`
  background: #ffff04;
  font-size: 1.4rem;
`;

export const Class = styled.span`
  color: #0000ff;
  width: 100%;
  margin: 1rem 0;
  font-size: 1.25rem;
  text-align: left;
  font-weight: 600;
`;

export const ClassInit = styled.span`
  color: rgba(45, 45, 45, 1);
  width: 100%;
  margin: 1rem 0;
  font-size: 1.25rem;
  text-align: left;
  font-weight: 600;
`;

export const Text = styled.p`
  width: 100%;
  color: #242424;
  font-size: 1rem;
  line-height: 1.75rem;
  margin: 10px 0;
  font-family: "Roboto", sans-serif;
`;

export const List = styled.ol`
  width: 100%;
  margin: 10px 0;
  counter-reset: li;

  li {
    color: #242424;
    margin: 5px 0;
    list-style: none;
    font-family: "Roboto", sans-serif;
  }

  li::before {
    content: counter(li) ". ";
    counter-increment: li;
    font-weight: 700;
  }
`;

export const Form = styled.form`
  width: 45vw;
  hr {
    width: 30%;
    border: 2px #1fdaf9 solid;
    transform: translateX(-50px);
    margin: 30px 0;
  }

  h2 {
    color: #0000ff;
    font-size: 1.75rem;
    font-weight: 600;
    margin: 5px 0;
  }

  @media (max-width: 768px) {
    width: 75vw;
  }

  @media (min-width: 1024px) {
    width: 52vw;
  }
`;

export const InputContainer = styled.div`
  margin: 10px 10px 30px;
  color: #242424;
`;

export const PersonalInputContainer = styled.div`
  margin: 20px 0;
  width: 100%;
  display: flex;
  justify-content: space-between;

  @media (max-width: 1210px) {
    flex-direction: column;
  }
`;

export const Input = styled.div`
  label {
    line-height: 20px;
    font-family: "Roboto", sans-serif;

    input {
      margin-right: 5px;
      margin-left: --10px;
    }

    a {
      color: #337ab7;
      text-decoration: none;
    }

    a:hover {
      color: #23527c;
      text-decoration: underline;
    }
  }
`;

export const Button = styled.button`
  background: #0000ff;
  box-shadow: 0px 3px 6px rgba(0, 122, 250, 0.35);
  padding: 20px;
  width: 40%;
  color: #fff;
  border: none;
  font-size: 1.5rem;
  font-weight: 600;
  border-radius: 5px;
  cursor: pointer;
`;

export const PersonalInput = styled.div`
  min-width: 49%;
  margin: 10px 0;

  label {
    display: flex;
    flex-direction: column;
    margin: 5px 0;
    color: #0000ff;

    input,
    select {
      padding: 10px;
      border: 1px solid #d2d2d2;
      border-radius: 5px;
      outline: none;
      color: #747474;
      font-size: 1.2rem;
      margin: 10px 0 20px;
      background: #fff;
      font-family: "Roboto", sans-serif;

      &::placeholder {
        font-size: 1.2rem;
        color: #d2d2d2;
      }
    }
  }
`;

export const SubmitInput = styled.div`
  margin: 20px 0;
  display: flex;
  flex-direction: column;

  label {
    color: #0000ff;
  }

  select {
    padding: 0.625rem;
    border: 1px solid #d2d2d2;
    border-radius: 5px;
    outline: none;
    color: #747474;
    font-size: 1.2rem;
    margin-top: 0.75rem;
    background: #fff;
    font-family: "Roboto", sans-serif;

    &::placeholder {
      font-size: 1.2rem;
      color: #d2d2d2;
    }
  }

  textarea {
    padding: 5px;
    margin: 10px 0;
    resize: none;
    border: 1px solid #707070;
    color: #707070;
    border-radius: 5px;
    font-size: 1.2rem;
    height: 200px;
    font-family: "Roboto", sans-serif;
  }
`;
